import { render, staticRenderFns } from "./Supplies.vue?vue&type=template&id=40e52e2b&scoped=true&"
import script from "./Supplies.vue?vue&type=script&lang=js&"
export * from "./Supplies.vue?vue&type=script&lang=js&"
import style0 from "./Supplies.vue?vue&type=style&index=0&id=40e52e2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e52e2b",
  null
  
)

export default component.exports